import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export type AnnouncementsResponse = Record<string, { show: boolean }>;

@Injectable({ providedIn: 'root' })
export class AnnouncementsService {
  private readonly url = '/:apiBase/announcements';

  constructor(private http: HttpClient) {}

  check(): Observable<AnnouncementsResponse> {
    return this.http.get<AnnouncementsResponse>(this.url);
  }
}
